<template>
  <down-view @download="downloadHandler"></down-view>
</template>

<script>
import DownView from "./components/DownView.vue";
import axios from "axios";
const _axiosInstance = axios.create({
  timeout: 15000,
});
import { logEventFun as $logEvent } from "./log";
export default {
  name: "bn_pc_down",
  inject: ['home'],
  components: {
    DownView,
  },
  data() {
    return {
      appName: "Buenovela",
      isIOS: false,
      bid: "0",
      channelCode: "BWEB00001",
      token: "fp8pcp",
      cid: 0,
      uuid: "",

      clipboardText: "",
      adjustObj: {},
      campaignList: [],
      ext: "",
      showLoading: true,
    };
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    // this.clipboardInstance.destroy();
  },
  methods: {
    init() {
      let u = window.navigator.userAgent;
      this.isIOS = !!u.match(/.+Mac OS X/);

      this.initParamsWithoutUTM();
      this.getInfoAndLog();
    },


    initParamsWithoutUTM() {
      const obj = this.home.extendObj;
      this.bid = obj.bookId || "0";
      this.channelCode = obj.channelCode;
      this.adjustObj = {
        ip: "0.0.0.0",
        token: this.token,
        bookId: this.bid,
        channelCode: this.channelCode,
        cId: this.cid,
        shareCode: 0,
        url: window.location.href,
        campaign: '0_0',
        ua: navigator.userAgent,
        ext: this.ext,
      };
    },

    downloadHandler(isIOS) {
      $logEvent({
        event: "xzapp", //下载app
        map: {
          ...this.adjustObj,
          uuid: this.uuid,
        },
      });
      if (isIOS) {
        window.location.href = "https://apps.apple.com/app/id1547565419";
      } else {
        window.location.href = "https://play.google.com/store/apps/details?id=com.fic.buenovela";
      }
    },

    loadingHandler(e) {
      e.preventDefault();
    },

    async getInfoAndLog() {
      const url = "https://www.goodnovel.com/remote_add";
      try {
        const result = await _axiosInstance.get(url, { responseType: "text" });
        this.showLoading = false;
        this.adjustObj.ip = result.data.toString().replace("\n", "");
        let text = "xlq_" + this.compile(this.adjustObj);
        this.clipboardText = text;
        $logEvent({
          event: "xzappxx", // 下载app信息
          map: {
            ...this.adjustObj,
            uuid: this.uuid,
          },
        });
      } catch (error) {
        this.showLoading = false;
        this.adjustObj.ip = "0.0.0.0";
        let text = "xlq_" + this.compile(this.adjustObj);
        this.clipboardText = text;
        $logEvent({
          event: "xzappxx", // 下载app信息
          map: {
            ...this.adjustObj,
            uuid: this.uuid,
          },
        });
      }
    },

    compile(code) {
      code = JSON.stringify(code);
      let res = [];
      code.split("").map((c, i) => {
        res.push((code.charCodeAt(i) + 2).toString(16));
      });
      return res.join("");
    },
  },
};
</script>

<style lang="scss" scoped>
.loading {
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading img {
  animation: turn 1s linear infinite;
}
@keyframes turn {
  0% {
    -webkit-transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(90deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(270deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
.wrap {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  // height: 100%;
  height: 100vh;
}
.wrap img {
  display: block;
  margin: 0 auto;
}
.mgt37 {
  margin-top: 37.5px;
}
.mgt26 {
  margin-top: 26px;
}
.h5 {
  font-size: 18px;
  font-family: SFProText-Bold, SFProText;
  font-weight: bold;
  color: #000000;
  margin-top: 9px;
  text-align: center;
}
p {
  font-size: 15px;
  font-family: SFProText-Regular, SFProText;
  font-weight: 400;
  color: #333333;
  margin-top: 8px;
  text-align: center;
}
</style>